import Login from "../../components/auth/login/Login.tsx";

function LoginPage() {
    return (
        <>
            <Login/>
        </>
    );
}

export default LoginPage;